export enum CardPaginationType {
    CardPagination = 'CardPagination',
    GetCards = 'GetCards',
    ListviewCardPagination = 'ListviewCardPagination',
    TimelineCardPagination = 'TimelineCardPagination'
}
